"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const PageRootWrapper = (props) => {
    const { children } = props;
    return react_1.default.createElement("div", { style: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            height: '100%'
        } }, children);
};
exports.default = PageRootWrapper;
//# sourceMappingURL=PageRootWrapper.js.map